export const signUp = (name, email, phone, password, params, successCallback, errorCallback) => {
  fetch(`/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...window.utmInfo,
      user: {
        ...params,
        name: name,
        email: email,
        phone: phone,
        password: password,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (successCallback) {
          successCallback(data.user);
        }
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        errorCallback(errors);
      }
    });
};

export const logOut = (successCallback) => {
  fetch(`/users/sign_out`, {
    method: 'DELETE',
  }).then(successCallback);
};

export const signIn = (email, password, rememberMe, onSuccess, onError) => {
  fetch(`/users/sign_in`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...window.utmInfo,
      user: {
        email: email,
        password: password,
        remember_me: rememberMe ? '1' : '',
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        if (data.errors) {
          onError(data.errors);
        } else {
          onError(['Invalid email or password. After 10 unsuccessful login attempts you will be locked out.']);
        }
      }
    })
    .catch((error) => {
      onError(['Invalid email or password. After 10 unsuccessful login attempts you will be locked out.']);
    });
};

export const recoverPassword = (email, onSuccess, onError) => {
  fetch(`/users/password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        email: email,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess();
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

export const resetPassword = (resetPasswordToken, password, onSuccess, onError) => {
  fetch(`/users/password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        reset_password_token: resetPasswordToken,
        password: password,
        password_confirmation: password,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

export const userUpdate = (updates, onSuccess, onError) => {
  fetch(`/api/v1/user`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user: {
        ...updates,
      },
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (onSuccess) {
          onSuccess(data.user);
        }
      } else {
        let errors = [];
        for (const [key, value] of Object.entries(data.errors)) {
          errors.push(`${snakeCaseToTitleCase(key)} ${value}`);
        }
        onError(errors);
      }
    });
};

export const userImpersonate = (userId, onSuccess, onError) => {
  fetch(`/api/v1/users/${userId}/impersonate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        onError(data.errors);
      }
    });
};

export const userStopImpersonate = (onSuccess, onError) => {
  fetch(`/api/v1/users/stop_impersonating`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        onError(data.errors);
      }
    });
};

export const getUser = (id, onSuccess, onError = () => {}) => {
  fetch(`/api/v1/users/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        onSuccess(data.user);
      } else {
        onError();
      }
    });
};

export const getUsers = (params, onSuccess) => {
  fetch(`/api/v1/users?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      onSuccess(data);
    });
};

export const getSurgeonPatientUsers = (params, onSuccess) => {
  return fetch(`/api/v1/users/surgeon_patient_users?${objToQueryString(params)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (onSuccess) {
        onSuccess(data);
      }
      return data;
    })
    .catch((error) => {
      console.error('Error fetching surgeon patient users:', error);
      if (onSuccess) {
        onSuccess([]); // or handle error case appropriately
      }
    });
};
